import React from 'react'
import EmptyCard from '@/components/UI/EmptyPages/EmptyCard'
import { AddIcon, EmptyStates } from '@/asset/icons'

const CompanyEmptyState = ({ handleAddCompany }) => {
    return (
        <EmptyCard
            title='Company Setup'
            subtitle={[
                'Get started by adding company information, locations and payment.',
            ].join('\n')}
            buttonText={'Add Company'}
            icon={<AddIcon />}
            emptyIcon={<EmptyStates.CompanyHouseIcon />}
            onClick={handleAddCompany}
        />
    )
}

export default CompanyEmptyState